import React, { Component } from "react";

class Policies extends Component {
  render() {
    return (
      <div style={styles.container}>
        <h1 style={styles.title}>Política de Privacidade</h1>

        <div style={styles.paragraph}>
          O aplicativo Brasil+Seguro foi desenvolvido com o objetivo de promover
          mais segurança pública e ambiental, permitindo que os usuários
          visualizem pontos críticos de risco em tempo real, como áreas com
          possibilidade de enchente, desabamento, incêndio, alagamento,
          deslizamento e outras ocorrências, além de receber alertas
          personalizados de acordo com a sua localização. Esta Política de
          Privacidade tem como finalidade explicar de maneira clara, acessível e
          transparente como os dados pessoais dos usuários são coletados,
          utilizados, armazenados, compartilhados e protegidos, em conformidade
          com a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018 –
          LGPD).
        </div>

        <div style={styles.paragraph}>
          O Brasil+Seguro coleta dados pessoais necessários para garantir o
          funcionamento adequado do aplicativo e a oferta de serviços
          personalizados. Entre os dados coletados estão informações de
          cadastro, como nome, e-mail e senha; dados de geolocalização, que
          permitem identificar e exibir pontos de risco próximos ao usuário;
          informações técnicas sobre o dispositivo e o sistema operacional; e
          dados de comunicação enviados por meio do suporte ou feedback. Esses
          dados são utilizados para exibir alertas sobre áreas de risco
          próximas, aprimorar a precisão das notificações, garantir a segurança
          e o bom funcionamento do aplicativo, comunicar atualizações e
          informações relevantes, cumprir obrigações legais e aprimorar a
          experiência geral de uso.
        </div>

        <div style={styles.paragraph}>
          O tratamento dos dados pessoais é realizado com base em fundamentos
          legais previstos na LGPD, incluindo o consentimento do usuário (art.
          7º, I), o cumprimento de obrigação legal ou regulatória (art. 7º, II)
          e o legítimo interesse do controlador, especialmente para fins de
          melhoria e eficiência do serviço (art. 7º, IX).
        </div>

        <div style={styles.paragraph}>
          Os dados pessoais poderão ser compartilhados com provedores de serviço
          essenciais para o funcionamento do aplicativo, como empresas
          responsáveis por hospedagem, sistemas de geolocalização, envio de
          notificações push e suporte técnico. Também poderão ser compartilhados
          com autoridades públicas em situações de emergência, risco à segurança
          ou cumprimento de obrigações legais, e com parceiros técnicos para
          análises e aprimoramento de funcionalidades, sempre de forma segura e,
          quando possível, anonimizada.
        </div>

        <div style={styles.paragraph}>
          O Brasil+Seguro pode utilizar cookies, SDKs e ferramentas analíticas
          para coletar informações sobre o uso do aplicativo, como frequência de
          acesso e preferências de navegação. Essas tecnologias auxiliam na
          melhoria contínua da experiência do usuário e na personalização dos
          alertas. O usuário pode optar por desativar ou gerenciar os cookies
          nas configurações de seu dispositivo, ciente de que algumas
          funcionalidades podem ser impactadas.
        </div>

        <div style={styles.paragraph}>
          A segurança das informações é uma prioridade. O Brasil+Seguro adota
          medidas técnicas e organizacionais adequadas para proteger os dados
          pessoais contra acessos não autorizados, perda, uso indevido,
          alteração ou divulgação indevida. Entre as medidas adotadas estão a
          criptografia de dados sensíveis, o controle de acesso restrito, o
          monitoramento contínuo de segurança e o armazenamento em servidores
          protegidos. No entanto, o usuário reconhece que, apesar de todos os
          esforços, nenhum sistema é totalmente imune a riscos.
        </div>

        <div style={styles.paragraph}>
          Os dados pessoais serão mantidos apenas pelo tempo necessário para
          cumprir as finalidades descritas nesta Política, atender obrigações
          legais e preservar direitos do controlador e do usuário. Após esse
          período, ou mediante solicitação do titular, os dados poderão ser
          anonimizados ou excluídos de forma segura, conforme critérios técnicos
          adequados.
        </div>

        <div style={styles.paragraph}>
          Em conformidade com a LGPD, o usuário tem direito de confirmar a
          existência de tratamento de dados, solicitar acesso, correção,
          atualização ou exclusão de suas informações pessoais, requerer a
          portabilidade para outro fornecedor de serviço, revogar o
          consentimento, obter informações sobre o compartilhamento de dados e
          solicitar a revisão de decisões automatizadas. Todas as solicitações
          podem ser feitas por meio do e-mail{" "}
          <a href="mailto:suporte@brasilmaisseguro.com.br">
            suporte@brasilmaisseguro.com.br
          </a>
          .
        </div>

        <div style={styles.paragraph}>
          Esta Política de Privacidade poderá ser atualizada periodicamente,
          seja por mudanças legais, técnicas ou operacionais. Sempre que houver
          alterações relevantes, o usuário será informado por meio do aplicativo
          ou por e-mail cadastrado. Recomenda-se que o usuário consulte esta
          Política regularmente para manter-se informado sobre como seus dados
          estão sendo tratados.
        </div>

        <div style={styles.paragraph}>
          Em caso de dúvidas, solicitações ou reclamações relacionadas à
          privacidade ou ao tratamento de dados pessoais, o usuário pode entrar
          em contato pelo e-mail{" "}
          <a href="mailto:suporte@brasilmaisseguro.com.br">
            suporte@brasilmaisseguro.com.br
          </a>
          .
        </div>

        <div style={styles.footer}>Última atualização: novembro de 2025.</div>
      </div>
    );
  }
}

const styles = {
  container: {
    maxWidth: 920,
    margin: "20px auto",
    padding: 18,
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    color: "#222",
  },
  title: { margin: 0, fontSize: 22, marginBottom: 12 },
  paragraph: { marginBottom: 12, lineHeight: 1.5, whiteSpace: "pre-wrap" },
  footer: { marginTop: 18, color: "#666", fontSize: 13 },
};

export { Policies };



// WEBPACK FOOTER //
// ./src/views/Policies/index.jsx